<template>
  <div class="md-container px-4">
    <section id="app-mobile" class="lg:mb-16 mb-10">
      <div class="flex flex-wrap lg:flex-nowrap justify-center items-center">
        <div class="w-full lg:w-1/2 lg:mr-6 lg:mb-0 mb-6">
          <img v-lazy-load data-src="@/assets/img/img-yd-app-mobile.svg" alt="" class="mx-auto">
        </div>
        <div class="w-full lg:w-1/2 lg:text-left text-center">
          <h4 class="font-bree-serif md:text-3xl lg:mb-8 mb-6" v-html="$t('downloadApp')" />
          <div class="">
            <img
              v-lazy-load data-src="@/assets/img/img-download-google-play.svg"
              alt=""
              class="inline-block sm:mr-4 sm:mb-0 mb-3 xs:w-auto w-3/5 cursor-pointer"
              @click="openNewTab(linkGooglePlayStore)"
            >
            <img
              v-lazy-load data-src="@/assets/img/img-download-app-store.svg"
              alt=""
              class="inline-block sm:mb-0 mb-3 xs:w-auto w-3/5 cursor-pointer"
              @click="openNewTab(linkAppleStore)"
            >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'DownloadApp',
  data: () => ({
    linkAppleStore: process.env.LINK_IOS,
    linkGooglePlayStore: process.env.LINK_ANDROID
  }),
  methods: {
    openNewTab (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>

</style>
